import React from "react";
import { connect } from "react-redux";

import VideolistAllItem from "./VideolistAllItem";

const VideolistAllItemContainer = (props) => (
  <VideolistAllItem
    id={props.id}
    className={props.className}
    name={props.name}
    totalcount={props.totalcount}
    totalsize={props.totalsize}
    totaltime={props.totaltime}
    songs={props.songs}
    selected={props.selected}
    highlighted={props.markItems.indexOf(props.id) !== -1}
    tags={props.tags}
    variant={props.variant}
    onlyOne={props.onlyOne}
    loading={props.loading && props.selectedForLoading}
    marker={props.marker}
  />
);

const stateToProps = (state, props) => ({
  markItems: [...state.marks[state.marks.current].items],
  selected: state.videolists_all.selected.indexOf(props.id) !== -1,
  selectedForLoading: state.videolists.selected.indexOf(props.id) !== -1,
  loading: state.videolists.loading,
  marker: state.videolists_all.clipSummery.videolists.indexOf(props.id) !== -1,
});

export default connect(stateToProps, null)(VideolistAllItemContainer);
